export const pointsEndpointIds = {
    AWARD_POINTS: 'AWARD_POINTS',
    ADD_PAID_OFF_PLATFORM_POINTS: 'ADD_PAID_OFF_PLATFORM_POINTS',
    INIT_POINTS_PAYOUT: 'INIT_POINTS_PAYOUT',
    CREATE_POINTS_APPLICATION: 'CREATE_POINTS_APPLICATION',
    GET_POINTS_APPLICATIONS: 'GET_POINTS_APPLICATIONS',
    SET_POINTS_APPLICATION_STATE: 'SET_POINTS_APPLICATION_STATE',
    UPDATE_CAMPAIGN_TERMS_ACCEPTED: 'UPDATE_CAMPAIGN_TERMS_ACCEPTED',
    GET_CAMPAIGN_TERMS_ACCEPTED: 'GET_CAMPAIGN_TERMS_ACCEPTED',
    LIST_CAMPAIGN_TERMS_ACCEPTED: 'LIST_CAMPAIGN_TERMS_ACCEPTED',
    CHECK_EXPIRED_POINTS_RESERVATIONS: 'CHECK_EXPIRED_POINTS_RESERVATIONS',
    GET_POINTS_ALLOWLIST_CREATORS: 'GET_POINTS_ALLOWLIST_CREATORS',
    ADD_POINTS_ALLOWLIST_CREATORS: 'ADD_POINTS_ALLOWLIST_CREATORS',
    UPDATE_POINTS_APPLICATION_ADMIN: 'UPDATE_POINTS_APPLICATION_ADMIN',
    INIT_POINTS_PAYOUT_ADMIN: 'INIT_POINTS_PAYOUT_ADMIN',
    SEND_DROP_LAUNCH_DATE_CHANGED_EMAIL: 'SEND_DROP_LAUNCH_DATE_CHANGED_EMAIL',
};
// TODO: hotfix, remove it later
export const STREAM_DATE_IGNORED_CAMPAIGN_IDS = [
    'a5021abc-a99e-4593-ac1d-90e133189c6e',
    '8a7ecf67-fe9f-4d52-b1ca-09ad4e6f36d5',
    '1258db9c-c77a-40c3-b0f0-6d49ca471152',
    'f13a2024-b37a-48ff-b642-e705eeafd7b0',
    'e844facf-971b-45c8-bef8-636501f11ad2',
    '2f37939a-26b1-4ff8-a584-7dd49dfb5628',
    '44a369fe-7d56-4060-b92a-3e40aa7472cc',
    '6be1cfa1-1b34-4805-8dac-fa184d9e6cbe',
    '6c1db9c4-28e3-49c8-9713-b679ba1be285',
    'd43c9a66-803c-4d1e-9b5a-f9ed60a919e3',
    '8af8c999-b2ce-4f1b-a711-67b6b1b03739',
    'a540c98c-ec33-443e-a263-c4b56fb43138',
];
